import Vue from 'vue';
import './assets/css/common.scss';
import App from './App.vue';
import axios from './utils/ajax.js';
import router from './router';
import '@/icons/index.js';
import { Table, TableColumn, Message } from 'element-ui';
// import VueRouter from 'vue-router'
// Vue.use(VueRouter)
Vue.use(Table);
Vue.use(TableColumn);

Vue.prototype.$axios = axios;
Vue.prototype.$message = Message;
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
